import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import ActivityGroup from './ActivityGroup.jsx';

const PlacemarkInfoPanel = ({
	title,
	closeSelectedPlacemarkInfoPanel,
	activities,
	datasetInfo,
	bulkActivities,
	setBulkActivities
}) => {
	return (
		<div className="placemarkInfoPanel">
			<div className="infoPanelHeader">
				<div className="placemarkTitle">{title}</div>
				<Button
					className="closeButton"
					onClick={closeSelectedPlacemarkInfoPanel}>
					<span className="glyphicon glyphicon-remove-circle leftGlyph"></span>
					Close
				</Button>
			</div>
			<div className="activityGroup">
				{
					activities.length
						? (
							<ActivityGroup
								activities={activities}
								datasetInfo={datasetInfo}
								bulkActivities={bulkActivities}
								setBulkActivities={setBulkActivities} />
						)
						: <div>This location has no visible activities.</div>
				}
			</div>
		</div>
	);
};

PlacemarkInfoPanel.propTypes = {
	title: PropTypes.string,
	closeSelectedPlacemarkInfoPanel: PropTypes.func,
	activities: PropTypes.array,
	datasetInfo: PropTypes.object,
	bulkActivities: PropTypes.array,
	setBulkActivities: PropTypes.func
};

export default PlacemarkInfoPanel;